export default __webpack_public_path__ + "static/media/acecomLogo.27729971.svg";